<div id="videoController" class="video-controller unselectable">
  <div class="seekContainer">
    <div id="seekbar" class="seekbar seekbar-complete" aria-label="video progress bar" tabindex="0" role="slider">
      <div id="seekbar-buffer" class="seekbar seekbar-buffer"></div>
      <div id="seekbar-play" class="seekbar seekbar-play"></div>
    </div>
  </div>
  <div id="playPauseBtn" class="btn-play-pause">
    <button tabindex="0"><span id="iconPlayPause" class="icon-play"></span></button>
  </div>
  <span id="videoTime" class="time-display" role="timer">00:00:00</span>
  <span id="videoDuration" class="duration-display" tabindex="0">00:00:00</span>
  <div id="muteBtn" class="btn-mute control-icon-layout">
    <button tabindex="0"><span id="iconMute" class="icon-mute-off"></span></button>
  </div>
  <input type="range" id="volumebar" class="volumebar" value="1" min="0" max="1" step="0.1" aria-valuetext="100%"/>
  <div id="trackSwitchBtn" class="control-icon-layout" tabindex="0">
    <span class="icon-tracks"></span>
  </div>
  {{#if transcript.in_controlbar}}
    <div class="transcript">
      <div id="transcriptBtn" class="btn-transcript">
        <button tabindex="0" aria-label="{{iconTranscript.caption}}" data-toggle="modal" data-target="#{{transcript.id}}">
            {{>icon uuid=cid prefix=iconTranscript.icon_prefix name=iconTranscript.icon_name sr_caption=iconTranscript.caption}}
        </button>
      </div>
      <div class="transcript-modal"></div>
    </div>
  {{/if}}
  <div id="captionBtn" class="btn-caption control-icon-layout">
    <button tabindex="0" aria-pressed="false"><span class="icon-caption"></span></button>
  </div>
  <div id="bitrateListBtn" class="control-icon-layout">
    <button tabindex="0" aria-pressed="false"><span class="icon-bitrate"></span></button>
  </div>
  <div id="fullscreenBtn" class="btn-fullscreen control-icon-layout">
    <button tabindex="0" aria-pressed="false"><span class="icon-fullscreen-enter"></span></button>
  </div>
</div>
